class PrivilegeValidationService {
  static CanAddClient(privileges, currentNbClient) {
    if (privileges.maxClient === -1) return true;
    return currentNbClient + 1 <= privileges.maxClient;
  }
  static ClientCanAddMedia(privileges, currentNbMedia) {
    if (privileges.maxMediaByClient === -1) return true;
    return currentNbMedia + 1 <= privileges.maxMediaByClient;
  }

  static ClientCanAddMedias() {
    return true;
  }
  static ClientCanAddNote(privileges, currentNbNote) {
    if (privileges.maxNoteByClient === -1) return true;
    return currentNbNote + 1 <= privileges.maxNoteByClient;
  }

  static ClientCanAddService(privileges, currentNbService) {
    if (privileges.maxServicesByClient === -1) return true;
    return currentNbService + 1 <= privileges.maxServicesByClient;
  }

  static CanUploadFile() {
    return true;
  }

  static CanAddHorse(privileges, currentNbHorse) {
    if (privileges.maxHorsesByClient === -1) return true;
    return currentNbHorse + 1 <= privileges.maxHorsesByClient;
  }
  static HorseCanAddMedia(privileges, currentNbMedia) {
    if (privileges.maxMediaByHorse === -1) return true;
    return currentNbMedia + 1 <= privileges.maxMediaByHorse;
  }
  static HorseCanAddMedias() {}

  static HorseCanAddNote(privileges, currentNbNote) {
    if (privileges.maxNoteByHorse === -1) return true;
    return currentNbNote + 1 <= privileges.maxNoteByHorse;
  }

  static HorseCanAddBodyMap(privileges, currentNbBodyMap) {
    if (privileges.maxBodyMapByHorse === -1) return true;
    return currentNbBodyMap + 1 <= privileges.maxBodyMapByHorse;
  }

  static CanArchive(privileges) {
    return privileges.canArchiveClientAndHorse;
  }

  static HorseCanAddService(privileges, currentNbService) {
    if (privileges.maxServicesByHorse === -1) return true;
    return currentNbService + 1 <= privileges.maxServicesByHorse;
  }

  static ServiceOccurenceCanAddMedia(privileges, currentNbMedia) {
    if (privileges.maxMediaByService === -1) return true;
    return currentNbMedia + 1 <= privileges.maxMediaByService;
  }
  static ServiceOccurenceCanAddMedias() {
    return true;
  }
  static ServiceOccurenceCanAddNote(privileges, currentNbNote) {
    if (privileges.maxNoteByService === -1) return true;
    return currentNbNote + 1 <= privileges.maxNoteByService;
  }

  static CanAddUserService(privileges, currentNbService) {
    if (privileges.maxUserServices === -1) return true;
    return currentNbService + 1 <= privileges.maxUserServices;
  }
}

export default PrivilegeValidationService;
